import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  apiBaseUrl = environment.apiBaseUrl;

  constructor(
    private _httpClient: HttpClient,
  ) { }

  AddChat(query:any,data: any) {
    return this._httpClient.post(`${this.apiBaseUrl}/chats${query}`, data);
  }

  getUnReadNotifications() {
    return this._httpClient.get(`${this.apiBaseUrl}/notifications/unreadCount`);
  }

  getNotifications(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/notifications/user${query}`);
  }

  addNotification(data: any) {
    return this._httpClient.post(`${this.apiBaseUrl}/notifications`, data);
  }

}
